import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route: AnyRoute = createFileRoute("/app/")({
  beforeLoad: () => {
    throw redirect({ to: "/app/dashboard" })
  },
  component: () => null,
})
